import { TableMode } from '@/models/TableMode';
import { EntityState, PayloadAction } from '@reduxjs/toolkit';
import { hostsAdapter } from '.';
import { BaseInformation } from '../../../models/games/BaseInformation';
import { GameState } from '../../../models/games/enums/GameState';
import { getIsRestState } from '../../../utils/commonFunc';
import { HostTable } from '../models';
import {
    BasePayload,
    DealerLoginPayload,
    GameInitPayload,
    RestPayload,
    StartBetPayload,
    UpdateGameRestPayload,
    UpdateIsRestartPayload,
    UpdateIsRoundCancelPayload,
    UpdateMaxBetByGameTypePayload,
    UpdateMultiplierPayload,
    UpdateRecordPayload,
    UpdateStatisticPayload,
    UpdateWinAmountPayload,
} from '../models/payloads';
// custom reducer
const dealerLogin = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<DealerLoginPayload>
) =>
    hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            DealerList: action.payload.dealer,
        },
    });
const gameInit = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<GameInitPayload>
) => {
    const game = action.payload.game;
    const liveData = action.payload.liveData;
    return hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            GameID: liveData.CurrentResult?.GameID,
            OldResult: game.OldResult,
            IsRest: game.IsRest,
            IsInternalTest: game.IsInternalTest,
            IsInited: true,
            IsRoundCancel: false,
            GameDelay: game.GameDelay,
        },
    });
};
const gameInitTimeout = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<BasePayload>
) => {
    return hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            IsInited: true,
        },
    });
};
const updateInformation = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<BaseInformation>
) => {
    hostsAdapter.updateOne(state, {
        id: action.payload.HostId,
        changes: {
            AllowSideBet: action.payload.AllowSideBet,
            HostId: action.payload.HostId,
            Rest: action.payload.Rest,
            Seat: action.payload.Seat,
            TableLimit: action.payload.TableLimit,
        },
    });
};
const updateRecord = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateRecordPayload>
) => {
    const hostId = action.payload.hostId;
    return hostsAdapter.updateOne(state, {
        id: hostId,
        changes: {
            Record: action.payload.record,
        },
    });
};
const updateGameRest = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateGameRestPayload>
) => {
    const isRest = getIsRestState(
        action.payload.onOrOff,
        action.payload.isTest
    );
    let changes: Partial<HostTable> = {
        IsRest: isRest,
        IsInternalTest:
            action.payload.isTest &&
            action.payload.onOrOff == TableMode.InternalTest,
    };
    return hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes,
    });
};
const startBet = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<StartBetPayload>
) => {
    const hostId = action.payload.hostId;
    const host = state.entities[hostId];
    if (host) {
        let record = host.Record;
        return hostsAdapter.updateOne(state, {
            id: hostId,
            changes: {
                GameID: action.payload.result.GameID,
                WinAmount: undefined,
                Record: record,
                IsRoundCancel: false,
            },
        });
    }
};
const updateStatistic = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateStatisticPayload>
) =>
    hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            Statistics: action.payload.statistics,
        },
    });
const rest = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<RestPayload>
) =>
    hostsAdapter.updateMany(
        state,
        action.payload.hostIds.map(id => ({
            id,
            changes: {
                IsRest: true,
                CurrentState: GameState.Idle,
            },
        }))
    );
const updateMaxBetByGameType = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateMaxBetByGameTypePayload>
) => {
    const hostIds = new Array<number>();
    for (const h of Object.values(state.entities)) {
        if (h && h.GameType === action.payload.gameType) hostIds.push(h.HostId);
    }
    return hostsAdapter.updateMany(
        state,
        hostIds.map(id => ({
            id,
            changes: {
                MaxBet: action.payload.maxBet,
            },
        }))
    );
};
const updateWinAmount = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateWinAmountPayload>
) =>
    hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            WinAmount: action.payload.amount,
        },
    });

//CMDScGameResultHandler & useInGamePopup
const updateIsRestart = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateIsRestartPayload>
) => {
    return hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            IsRestart: action.payload.isRestart,
        },
    });
};
const updateIsRoundCancel = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateIsRoundCancelPayload>
) => {
    return hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            IsRoundCancel: action.payload.isRoundCancel,
        },
    });
};
const updateMultiplier = (
    state: EntityState<HostTable, number>,
    action: PayloadAction<UpdateMultiplierPayload>
) => {
    return hostsAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            Multiplier: action.payload.multiplier,
        },
    });
};
export const hostsReducers = {
    dealerLogin,
    gameInit,
    gameInitTimeout,
    updateInformation,
    updateRecord,
    updateGameRest,
    startBet,
    updateStatistic,
    rest,
    updateMaxBetByGameType,
    updateWinAmount,
    updateIsRestart,
    updateIsRoundCancel,
    updateMultiplier,
};
